import { StoreAction, XmAction } from 'store/actions';
import { DeviceReturnEligible, FindMyDeviceStatus, ReasonCodes, ReturnInfo } from './models';

export function reasonCodesReducer(state: ReasonCodes, action: XmAction<ReasonCodes>): ReasonCodes {
    switch (action.type) {
        case StoreAction.GET_REASON_CODES:
            return action.payload;
        default:
            return state;
    }
}

export function deviceReturnReducer(state: DeviceReturnEligible[] = [], action: XmAction<DeviceReturnEligible>): DeviceReturnEligible[] {
    switch (action.type) {
        case StoreAction.GET_DEVICE_RETURN_ELIGIBLE:
            return [ ...state, action.payload ];
        case StoreAction.CLEAR_DEVICE_RETURN_ELIGIBLE:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            const newState: DeviceReturnEligible[] = state.filter((item: DeviceReturnEligible) => item.deviceId !== action.filters.deviceId);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function findMyDeviceStatusReducer(state: FindMyDeviceStatus[] = [], action: XmAction<FindMyDeviceStatus>): FindMyDeviceStatus[] {
    switch (action.type) {
        case StoreAction.GET_FIND_MY_DEVICE_STATUS:
            return [ ...state, action.payload ];
        default:
            return state;
    }
}

export function returnInfoReducer(state: ReturnInfo, action: XmAction<ReturnInfo>): ReturnInfo {
    switch (action.type) {
        case StoreAction.INITIATE_RETURN:
            return action.payload;
        default:
            return state;
    }
}
